import styled from '@emotion/styled';
import { Button, Dialog, Typography } from '@material-ui/core';
import { COLOR_TEXT_MAIN } from '../../../../theme/colors';
import LoadingButton from '../LoadingButton';

export const StyledModal = styled(Dialog)(``);

export const ModalContent = styled('div')(`
  padding: 24px;
`);

export const ModalFooter = styled('div')(`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  border-top: 1px solid #E6E7E8;
  padding: 16px 24px;
  background: #F5F6F7;
`);

export const ModalTitle = styled(Typography)(`
  font-size: 18px;
  font-weight: 700;
  color: #4C566C;
  margin-bottom: 8px;
`);

export const ModalText = styled(Typography)(`
  white-space: pre-wrap;
  font-size: 14px;
  color: #4C566C;
`);

export const ModalCancelButton = styled(Button)(`
  color: ${COLOR_TEXT_MAIN};
  height: 32px;
  font-size: 12px;
  background: #FFFFFF;
  font-weight: 800;
  border: 1.5px solid #E6E7E8;
  border-radius: 4px;
  padding: 10px 12px;
  margin-right: 12px;
  :hover {
    background: #FFFFFF;
  }
`);

export const ModalButton = styled(LoadingButton)(`
color: #FFFFFF;
height: 32px;
font-size: 12px;
background: ${COLOR_TEXT_MAIN};
font-weight: 800;
border-radius: 4px;
padding: 10px 12px;
:hover {
  background: #707889;
  border-color: #707889;
}
:disabled {
  background: #E6E7E8;
  color: rgba(75, 85, 106, 0.24);
  border: rgba(75, 85, 106, 0.24);
}
`);
